// local
import { mapById, sortString } from 'app/lib/helper';

const SORT_SUPPLIER = (a, b) => {
    return sortString(a.name, b.name);
};

const SORT_PATIENT = (a, b) => {
    return sortString(a.name, b.name);
};

const initialState = {
    loading: false,
    suppliers: [],
    totalPendingCylinders: 0,
};

const ACTION_KEY = 'REQUEST_DELIVERY';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            let { totalPendingCylinders, suppliers } = action.payload;
            suppliers = suppliers.map(supplier => {
                const patients = supplier.patients.map(patient => ({
                    ...patient,
                    pendingCylinderQtdEdit: patient.pendingCylinderQtd,
                }));
                patients.sort(SORT_PATIENT);
                return {
                    ...supplier,
                    patients,
                };
            });
            suppliers.sort(SORT_SUPPLIER);
            return {
                ...state,
                loading: false,
                suppliers,
                totalPendingCylinders,
            };
        }
        case `${ACTION_KEY}_RESET`: {
            return {
                ...state,
                suppliers: [],
                totalPendingCylinders: 0,
            };
        }
        case `${ACTION_KEY}_UPDATE_QTD`: {
            const { supplierId, patientId, pendingCylinderQtdEdit, diff } = action.payload;
            return {
                ...state,
                suppliers: mapById(state.suppliers, supplierId, supplier => {
                    return {
                        ...supplier,
                        pendingCylinderQtd: supplier.pendingCylinderQtd + diff,
                        patients: mapById(supplier.patients, patientId, patient => {
                            return {
                                ...patient,
                                pendingCylinderQtdEdit,
                            };
                        }),
                    };
                }),
                totalPendingCylinders: state.totalPendingCylinders + diff,
            };
        }
        default:
            return state;
    }
};

export default reducer;
